module.exports = __webpack_public_path__ + "static/proje-baslat1-3fc5b8191e1ad3a74a4d7b06a448f2ed.png";